import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import { Formik, Form } from "formik";
import { useDispatch, useSelector } from "react-redux";
import LeaveViewController from "../../redux/actions/leaveApiAction";
import EmployeeProfileVeiwController from "../../redux/actions/EmployeeProfileApiAction";

const AddLeaveBalanceFormModal = ({ show, handleClose, initialData = null }) => {
  const dispatch = useDispatch();
  const { getEmployees } = EmployeeProfileVeiwController();
  const { addLeaveBalance, updateLeaveBalance } = LeaveViewController();
  const { employee_data } = useSelector((state) => state.employeeProfile);
  const isEdit = Boolean(initialData?.id);

  const [initialValues, setInitialValues] = useState({
    employee: "",
    leave_year: new Date().getFullYear(),
    paid_leave_balance: 0,
    unpaid_leave_balance: 0,
    carry_forward_days: 0,
  });

  useEffect(() => {
    dispatch(getEmployees());

    if (show && initialData) {
      setInitialValues({
        employee: initialData.employee.id || "",
        leave_year: initialData.leave_year || new Date().getFullYear(),
        casual_leave_balance: initialData.casual_leave_balance,
        sick_leave_balance: initialData.sick_leave_balance,
        maternity_leave_balance: initialData.maternity_leave_balance,
        marriage_leave_balance: initialData.marriage_leave_balance,
        compensatory_off_leave_balance: initialData.compensatory_off_leave_balance,
        unpaid_leave_balance: initialData.unpaid_leave_balance || 0,
        carry_forward_days: initialData.carry_forward_days || 0,
      });
    } else if (show && !initialData) {
      setInitialValues({
        employee: "",
        leave_year: new Date().getFullYear(),
        casual_leave_balance: 0,
        sick_leave_balance: 0,
        maternity_leave_balance:0,
        marriage_leave_balance:0,
        compensatory_off_leave_balance: 0,
        unpaid_leave_balance: 0,
        carry_forward_days: 0,
      });
    }
  }, [show, initialData, dispatch]);

  const handleSubmit = (values, { resetForm }) => {
    const action = isEdit
      ? updateLeaveBalance(initialData.id, values)
      : addLeaveBalance(values);

    dispatch(action)
      .then(() => {
        resetForm();
        handleClose();
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
      });
  };

  return (
    <Dialog open={show} onClose={handleClose} fullWidth maxWidth="xl">
      <DialogTitle>
        {isEdit ? "Edit Leave Balance" : "Manage Leave Balance"}
      </DialogTitle>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        {({ values, handleChange }) => (
          <Form>
            <DialogContent dividers>
              <Grid container spacing={2}>
                {/* Employee */}
                <Grid item xs={12}>
                 <TextField
  select
  label="Employee"
  name="employee"
  value={values.employee}
  onChange={handleChange}
  fullWidth
  SelectProps={{ native: true }}
  InputLabelProps={{ shrink: true }} // 🔥 keeps label always floating
>
  <option value="" disabled>
    Select Employee
  </option>
  {employee_data?.employees?.map((emp) => (
    <option key={emp.id} value={emp.id}>
      {emp.first_name} {emp.last_name}
    </option>
  ))}
</TextField>

                </Grid>

                {/* Leave Year */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Leave Year"
                    name="leave_year"
                    type="number"
                    value={values.leave_year}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>

                {/* Paid Leave */}
                <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          type="number"
          label="Casual Leave"
          name="casual_leave_balance"
          value={values.casual_leave_balance }
          onChange={handleChange}
         
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          type="number"
          label="Sick Leave"
          name="sick_leave_balance"
          value={values.sick_leave_balance }
          onChange={handleChange}
          
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          type="number"
          label="Maternity Leave"
          name="maternity_leave_balance"
          value={values.maternity_leave_balance }
          onChange={handleChange}
          
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          type="number"
          label="Marriage Leave"
          name="marriage_leave_balance"
          value={values.marriage_leave_balance}
          onChange={handleChange}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          type="number"
          label="Compensatory Off"
          name="compensatory_off_leave_balance"
          value={values.compensatory_off_leave_balance}
          onChange={handleChange}
          
        />
      </Grid>

      {/* Unpaid Leave Balance */}
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          type="number"
          label="Unpaid Leave Balance"
          name="unpaid_leave_balance"
          value={values.unpaid_leave_balance }
          onChange={handleChange}
          
          
        />
      </Grid>

                {/* Carry Forward */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Carry Forward Leave"
                    name="carry_forward_days"
                    type="number"
                    value={values.carry_forward_days}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button type="submit" variant="contained" color="primary">
                {isEdit ? "Update" : "Submit"}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddLeaveBalanceFormModal;




















// import React, { useEffect, useState } from "react";
// import "../../styles/styles.css";
// import "../../styles/layout.css";
// import { Row, Col, Modal, Container, Form } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
// import MasterViewController from "../../redux/actions/masterApiActions";
// import LeaveViewController from "../../redux/actions/leaveApiAction";


// const AddLeaveBalanceFormModal =() =>{
//     const [showModal, setShowModal] = useState(false);
//     const [editMode, setEditMode] = useState(false); // To track if it's edit mode
//     const [formData, setFormData] = useState({
//         id: "",
//         employee: "",
//         leave_year: new Date().getFullYear(),
//         paid_leave_balance: 0,
//         unpaid_leave_balance: 0,
//         carry_forward_days: 0,
//     });

//   const dispatch = useDispatch();
//   const { getEmployees } = MasterViewController();
//   const { employees } = useSelector((state) => state.master);
//   const { addLeaveBalance, updateLeaveBalance } = LeaveViewController();
//   const { leaveBalance } = useSelector((state) => state.leave);

//   useEffect(() => {
//       dispatch(getEmployees());
      
//     }, []);


//     // Open modal for creating a new leave balance
//   const handleOpenModal = () => {
//     setEditMode(false);
//     setFormData({
//       id: "",
//       employee: "",
//       leave_year: new Date().getFullYear(),
//       paid_leave_balance: 0,
//       unpaid_leave_balance: 0,
//       carry_forward_days: 0,
//     });
//     setShowModal(true);
//   };

//   // Open modal for editing an existing leave balance
//   const handleEdit = (balance) => {
//     setEditMode(true);
//     setFormData({
//       id: balance.id,
//       employee: balance.employee.id,
//       leave_year: balance.leave_year,
//       paid_leave_balance: balance.paid_leave_balance,
//       unpaid_leave_balance: balance.unpaid_leave_balance,
//       carry_forward_days: balance.carry_forward_days,
//     });
//     setShowModal(true);
//   };

//   // Handle form change
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // Handle form submission for add/edit
//   const handleSubmit = () => {
//     if (editMode) {
//       dispatch(updateLeaveBalance(formData.id, formData));
//     } else {
//       dispatch(addLeaveBalance(formData));
//     }
//     setShowModal(false);
//   };

//   return(
//    <div>
//      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>{editMode ? "Edit Leave Balance" : "Manage Leave Balance"}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Container>
//             <Form>
//               <Form.Group>
//                 <Form.Label>Employee</Form.Label>
//                 <Form.Select name="employee" value={formData.employee} onChange={handleChange}>
//                   <option value="">Select Employee</option>
//                   {employees.map((emp) => (
//                     <option key={emp.id} value={emp.id}>
//                       {emp.first_name} {emp.last_name}
//                     </option>
//                   ))}
//                 </Form.Select>
//               </Form.Group>

//               <Form.Group>
//                 <Form.Label>Leave Year</Form.Label>
//                 <Form.Control
//                   type="number"
//                   name="leave_year"
//                   value={formData.leave_year}
//                   onChange={handleChange}
                
//                 />
//               </Form.Group>

//               <Form.Group>
//                 <Form.Label>Paid Leave Balance</Form.Label>
//                 <Form.Control type="number" name="paid_leave_balance" value={formData.paid_leave_balance} onChange={handleChange} />
//               </Form.Group>

//               <Form.Group>
//                 <Form.Label>Unpaid Leave Balance</Form.Label>
//                 <Form.Control type="number" name="unpaid_leave_balance" value={formData.unpaid_leave_balance} onChange={handleChange} />
//               </Form.Group>

//               <Form.Group>
//                 <Form.Label>Carry Forward Leave</Form.Label>
//                 <Form.Control type="number" name="carry_forward_days" value={formData.carry_forward_days} onChange={handleChange} />
//               </Form.Group>

//               <div className="d-flex justify-content-end mt-3">
//                 <Button variant="contained" onClick={handleSubmit}>
//                   {editMode ? "Update" : "Submit"}
//                 </Button>
//               </div>
//             </Form>
//           </Container>
//         </Modal.Body>
//       </Modal>
//    </div>
//   );

// }

//  export default AddLeaveBalanceFormModal;
